import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {
    FcpButtonModule,
    FcpDropdownModule,
    FcpFormFieldModule,
    FcpInputModule,
    FcpCheckboxModule
} from 'fc-ui-components';
import { TranslateModule } from '@ngx-translate/core';
import { UiComponentsModule } from 'shared/ui-components';

import { StoreInfoFormComponent } from './store-info-form.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '../../../../../../order-management/retailer-platform/manage-stores/shared';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        UiComponentsModule,
        TranslateModule,
        FcpDropdownModule,
        FcpButtonModule,
        MatTooltipModule,
        FormsModule,
        FcpFormFieldModule,
        FcpInputModule,
        FcpCheckboxModule
    ],
    declarations: [StoreInfoFormComponent],
    exports: [StoreInfoFormComponent]
})
export class StoreInfoFormModule {}
